var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"stat"},[_c('div',[_vm._v(_vm._s(_vm.price))]),_c('div',{class:{'green': _vm.isPositive(), 'red': _vm.isNegative()}},[_vm._v(_vm._s(_vm.change))])])])}
var staticRenderFns = []

export { render, staticRenderFns }